export function OrientationLockManager() {
  // Do not lock anything on web
  return null;
}
